import { useSelector } from "react-redux";
import { State } from "../../../../state/store";
import { useMemo } from "react";
import { CareRecipientDetail } from "../../../../domain/assessment/CareRecipientDetail";
import { Height } from "../../../../domain/assessment/Height";
import { Weight } from "../../../../domain/assessment/Weight";
import { getLifeStatusFromValue } from "../../../../domain/assessment/LifeStatus";
import { getFamilyDistanceFromValue } from "../../../../domain/assessment/FamilyDistance";
import { getNursingDegreeFromValue } from "../../../../domain/assessment/NursingDegree";
import { getDiseaseFromValue } from "../../../../domain/assessment/Disease";
import { getDiureticFromValue } from "../../../../domain/assessment/Diuretic";
import { OtherDiseases } from "../../../../domain/assessment/OtherDiseases";
import { getBathAtHomeFromValue } from "../../../../domain/assessment/BathAtHome";

export const useAssessmentInfo = () => {
    const careRecipientDetailJson = useSelector((state: State) => state.assessmentInfo.careRecipientDetail);
    const sufferedDiseaseJsonArray = useSelector((state: State) => state.assessmentInfo.sufferedDisease);
    const otherSufferedDiseasesJson = useSelector((state: State) => state.assessmentInfo.otherSufferedDiseases);
    const dosingMedicineJson = useSelector((state: State) => state.assessmentInfo.dosingMedicine);

    // コンポーネントでのuseEffect無限ループ対策
    const sufferedDiseaseArray = useMemo(() => (
        sufferedDiseaseJsonArray.map(it => (getDiseaseFromValue(it.disease)))
    ), [sufferedDiseaseJsonArray]);
    
    return {
        careRecipientDetail: CareRecipientDetail.from(
            careRecipientDetailJson.height ? Height.from(careRecipientDetailJson.height) : Height.fromNothing(),
            careRecipientDetailJson.weight ? Weight.from(careRecipientDetailJson.weight) : Weight.fromNothing(),
            getLifeStatusFromValue(careRecipientDetailJson.weekdayLifeStatus),
            getLifeStatusFromValue(careRecipientDetailJson.holidayLifeStatus),
            getFamilyDistanceFromValue(careRecipientDetailJson.familyDistance),
            getNursingDegreeFromValue(careRecipientDetailJson.nursingDegree),
            getBathAtHomeFromValue(careRecipientDetailJson.bathAtHome),
        ),
        sufferedDisease: sufferedDiseaseArray,
        otherSufferedDiseases: OtherDiseases.fromString(otherSufferedDiseasesJson.diseases),
        dosingMedicine: getDiureticFromValue(dosingMedicineJson.diuretic)
    };
};
